module.exports = __webpack_public_path__ + "img/myguard_pro_banner_02.ae69b94a.jpg";